import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=e960c2c2&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"
import style0 from "./welcome.vue?vue&type=style&index=0&id=e960c2c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e960c2c2",
  null
  
)

export default component.exports